/* Keep Judge.me's server-rendered content; hydrate its review module near view. */
(function () {
  'use strict';
  var loading = new Map();
  function hydrate(widget) {
    var file = widget.dataset.deferredEntryPoint;
    var base = window.jdgm && window.jdgm.CDN_BASE_URL;
    if (!file || !base) return Promise.resolve();
    var url = new URL(file, base).href;
    widget.dataset.entryPoint = file;
    if (loading.has(url)) return loading.get(url);
    var work = fetch(new URL('manifest.json', base).href)
      .then(function (response) { if (!response.ok) throw Error('Review styles unavailable'); return response.json(); })
      .then(function (manifest) {
        var visited = new Set();
        function styles(key) {
          if (visited.has(key)) return;
          visited.add(key);
          var entry = manifest[key];
          if (!entry) return;
          (entry.css || []).forEach(function (file) {
            var href = new URL(file, base).href;
            if (Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(function (link) { return link.href === href; })) return;
            var link = document.createElement('link'); link.rel = 'stylesheet'; link.href = href; document.head.appendChild(link);
          });
          (entry.imports || []).forEach(styles);
        }
        styles(widget.dataset.entryKey);
      })
      // Same fallback as the app loader: the module can run if the manifest fails.
      .catch(function () {})
      .then(function () {
        return new Promise(function (resolve, reject) {
          var script = document.createElement('script'); script.type = 'module'; script.src = url;
          script.onload = resolve; script.onerror = reject; document.head.appendChild(script);
        });
      }).then(function () { widget.removeAttribute('data-deferred-entry-point'); })
      .catch(function () { loading.delete(url); });
    loading.set(url, work);
    return work;
  }
  function init() {
    document.querySelectorAll('[data-deferred-entry-point]').forEach(function (widget) {
      if (widget.dataset.deferredReady) return;
      widget.dataset.deferredReady = 'true';
      function load() { return hydrate(widget); }
      if (!('IntersectionObserver' in window) || /judgeme|jdgm/.test(location.hash + location.search)) load();
      else {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect(); load();
          }
        }, { rootMargin: '800px 0px' });
        observer.observe(widget);
      }
      widget.addEventListener('focusin', load);
      widget.addEventListener('pointerenter', load, { once: true });
      // A failed download is retried on an explicit interaction.
      widget.addEventListener('click', load);
      window.addEventListener('hashchange', function () { if (/judgeme|jdgm/.test(location.hash)) load(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
